var GoogleMap = React.createClass({displayName: "GoogleMap",
    componentDidMount: function () {
        var isDraggable = true;
        if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
            isDraggable = true;
        }
        var getZoom = 5;
        if ($(".map-container").data("centermap").length>0) {
            var mapZoom = $(".map-container").data("centermap");
            getZoom = mapZoom.split(",")[2];
        }
        else {
            getZoom = this.props.model.InitialZoom;
        }
       
        var mapOptions = {
            center: this.mapCenterLatLng(),
            zoom: parseInt(getZoom),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: JSON.parse(this.props.model.Style),
            draggable: isDraggable,
            panControl: true,
            scrollwheel: true,
            gestureHandling: 'greedy'
        },
        map = new google.maps.Map(ReactDOM.findDOMNode(this), mapOptions);
        
        var infowindow = new google.maps.InfoWindow({
            maxWidth: this.props.model.InfoWindowWidth
        });
        var marker, i;
        var markers = [];
        var markerCluster = new MarkerClusterer(map, []);
        var iconOptions = JSON.parse(this.props.model.DefaultIconStyle);
        var icon = {
            url: iconOptions.url,
            scaledSize: new google.maps.Size(parseInt(iconOptions.Width), parseInt(iconOptions.Height))
        };

        $('#type-normal').on('click', function () {
            for (i = 0; i < markers.length; i++) {
                if (markers[i].typeNormal === "True") {
                    markers[i].setVisible(true);
                } else {
                    markers[i].setVisible(false);
                }
            }
            markerCluster.clearMarkers();
            markerCluster = new MarkerClusterer(map, markers.filter(function (x) { return x.visible; }), clusterOptions);
            markerCluster.repaint();
        });

        $('#type-equipment').on('click', function () {
            for (i = 0; i < markers.length; i++) {
                if (markers[i].typeEquipment === "True") {
                    markers[i].setVisible(true);
                } else {
                    markers[i].setVisible(false);
                }
            }
            markerCluster.clearMarkers();
            markerCluster = new MarkerClusterer(map, markers.filter(function (x) { return x.visible; }), clusterOptions);
            markerCluster.repaint();
            map.setZoom(6);
        });

        $('#type-gascenter').on('click', function () {
            for (i = 0; i < markers.length; i++) {
                if (markers[i].typeGasCenter === "True") {
                    markers[i].setVisible(true);
                } else {
                    markers[i].setVisible(false);
                }
            }
            markerCluster.clearMarkers();
            markerCluster = new MarkerClusterer(map, markers.filter(function (x) { return x.visible; }), clusterOptions);
            markerCluster.repaint();
            map.setZoom(6);
        });
        
        $('#type-automat').on('click', function () {
            for (i = 0; i < markers.length; i++) {
                if (markers[i].typeGasautomat === "True") {
                    markers[i].setVisible(true);
                } else {
                    markers[i].setVisible(false);
                }
            }
            markerCluster.clearMarkers();
            markerCluster = new MarkerClusterer(map, markers.filter(function (x) { return x.visible; }), clusterOptions);
            markerCluster.repaint();
            map.setZoom(6);
        });

        $('#js-mapsearch').on('click', function () {
            var geocoder = new google.maps.Geocoder();
            var searchString = $('#js-mapsearch-input');
            var country = "";
            var geocodeSearchString = searchString.val();

            $.get("/umbraco/MapGenerator/MapGeneratorApi/GetAdvancedSearchString?input=" + geocodeSearchString, function(data){
                geocodeSearchString = data["SearchString"];
                country = data["Country"];
            })
            .always(function(){      
                
                var componentRestrictions = {
                    'country': country
                };

                if(country == null) {
                    componentRestrictions = {};
                }
                
                geocoder.geocode({ 'address': geocodeSearchString, 'componentRestrictions': componentRestrictions
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        hideError();
                        var latitude = results[0].geometry.location.lat();
                        var longitude = results[0].geometry.location.lng();
                        map.setCenter(new google.maps.LatLng(latitude, longitude));
                        map.setZoom(10);
                    }
                    else {
                        showError(geocodeSearchString);
                        map.setZoom(7);
                    }
                });
            });
        });

        $('#js-mapsearch-input').keyup(function (e) {
            if (e.keyCode == 13) {
                // Do something
                $('#js-mapsearch').click();
            }
        });

        var showError = function (searchValue) {
            var searchInputContainer = $('.standard-map #js-mapsearch-input');
            console.log(searchInputContainer);
            var autocomplete = $('#autocomplete');
            var content = '';
            var errorMsg = autocomplete.attr('data-error-msg').replace('{0}', searchValue);

            var headerTemplate = '<div class="mapsearch-autocomplete__header mapsearch-autocomplete__header--error js-error-msg"><span><img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4OC40NTEgNDg4LjQ1MSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDg4LjQ1MSA0ODguNDUxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCI+CjxnPgoJPHBhdGggZD0iTTQ4NC4xMjUsNDEyLjAxM2wtMjEyLjItMzY3LjZjLTEyLjMtMjEuMy00My4xLTIxLjMtNTUuNCwwbC0yMTIuMiwzNjcuNmMtMTIuMywyMS4zLDMuMSw0OCwyNy43LDQ4aDQyNC40ICAgQzQ4MS4wMjUsNDYwLjAxMyw0OTYuNDI1LDQzMy4zMTMsNDg0LjEyNSw0MTIuMDEzeiBNMjQ0LjUyNSwxNTcuNjEzYzEzLjYsMCwyNC42LDExLjMsMjQuMiwyNC45bC00LDEzOS42ICAgYy0wLjMsMTEtOS4zLDE5LjctMjAuMywxOS43cy0yMC04LjgtMjAuMy0xOS43bC0zLjktMTM5LjZDMjE5LjkyNSwxNjguOTEzLDIzMC44MjUsMTU3LjYxMywyNDQuNTI1LDE1Ny42MTN6IE0yNDQuMjI1LDQxMC4xMTMgICBjLTEzLjksMC0yNS4yLTExLjMtMjUuMi0yNS4yYzAtMTMuOSwxMS4zLTI1LjIsMjUuMi0yNS4yczI1LjIsMTEuMywyNS4yLDI1LjJTMjU4LjEyNSw0MTAuMTEzLDI0NC4yMjUsNDEwLjExM3oiIGZpbGw9IiNGRkZGRkYiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" />' + errorMsg + '</span></div>';
            content += headerTemplate;

            autocomplete.html(content);
            autocomplete.collapse('show');
            searchInputContainer.addClass('remove-upper-radius');
        };

        var hideError = function () {
            var searchInputContainer = $('.standard-map #js-mapsearch-input');
            var autocomplete = $('#autocomplete');
            autocomplete.collapse('hide');
            searchInputContainer.removeClass('remove-upper-radius');
        }

        var ajaxResult = {};
        
        for (i = 0; i < this.props.model.Nodes.length; i++) {
            if (this.props.model.Nodes[i]["Coordinates"]) {
                var coords = this.props.model.Nodes[i]["Coordinates"].split(",");
                
                var pinIcon = icon;

                if (this.props.model.Nodes[i]["typeNormal"] === "True") {
                    pinIcon = '/App_Plugins/NovicellMapBuilder/Images/map-pin.png';
                }

                if (this.props.model.Nodes[i]["typeEquipment"] === "True") {
                    pinIcon = '/App_Plugins/NovicellMapBuilder/Images/map-pin-grey.png';
                }

                if (this.props.model.Nodes[i]["typeGasCenter"] === "True") {
                    pinIcon = '/App_Plugins/NovicellMapBuilder/Images/map-pin-blue.png';
                }

                if (this.props.model.Nodes[i]["typeGasautomat"] === "True") {
                    pinIcon = '/App_Plugins/NovicellMapBuilder/Images/map-pin-darkgreen.png';
                }

                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(coords[0], coords[1]),
                    title: this.props.model.Nodes[i]["Title"],
                    icon: pinIcon,
                    map: map,
                    zip: this.props.model.Nodes[i]["Zip"],
                    typeGasCenter: this.props.model.Nodes[i]["typeGasCenter"],
                    typeGasautomat: this.props.model.Nodes[i]["typeGasautomat"],
                    typeEquipment: this.props.model.Nodes[i]["typeEquipment"],
                    typeNormal: this.props.model.Nodes[i]["typeNormal"],
                    customerNumber: this.props.model.Nodes[i]["customerNumber"]
                });
                
                if (this.props.model.UseInfoWindows) {
                    google.maps.event.addListener(marker, "click", (function (infoWindows, marker, i) {
                        var str = infoWindows[i].replace(/\\\"/g, "\"");
                        str = str.replace(/\\u([\d\w]{4})/gi, function (match, grp) {
                            return String.fromCharCode(parseInt(grp, 16));
                        });
                        str = str.replace(/(?:\\[rn])+/g, "");

                        return function () {
                            infowindow.setContent(str);
                            if (marker.typeGasautomat) {
                                $.ajax({
                                    // url: "https://bulk.kosangas.dk/system/automat.pgm/customer/5767",
                                    url: "https://bulk.kosangas.dk/system/automat.pgm/customer/" + marker.customerNumber,
                                    success: function (result) {
                                        ajaxResult = JSON.parse(result);
                                    }
                                });
                            }
                            infowindow.open(map, marker);
                            setTimeout(function () {
                                var modal = $('.modal');
                                $('.see-products').on('click', function () {
                                    modal.addClass('modal--active');
                                    showContent();
                                });

                                $('.js-close-modal').on('click', function () {
                                    modal.removeClass('modal--active');
                                    setTimeout(function () {
                                        $('#js-modal__content-inner').empty();
                                    }, 500);

                                });
                            });
                        }
                    })(this.props.infoWindows, marker, i));
                }

                markers.push(marker);
            }
        }

        function showContent() {
            var image = '/dist/images/kompositflaske.svg';

            //for each item in the array:
            var product = ajaxResult;
            var productTemplate = document.querySelector(".js-product-template").content.cloneNode(true);

            // var oldProductList = productTemplate.querySelector('.modal__products-list');
            // oldProductList.remove();

            var productList = document.createElement('div');
            productList.classList.add('modal__products-list');

            for (var index = 0; index < product.Items.length; index++) {
                var item = product.Items[index];

                var productContainer = document.createElement('div');
                productContainer.classList.add('product');

                if (item.Product == '2016') {
                    image = '/dist/images/stalflaske.svg';
                }

                var icon = document.createElement('img');
                icon.classList.add('product-icon');
                icon.src = image;
                productContainer.appendChild(icon);

                var info = document.createElement('div');
                info.classList.add('product-info');
                productContainer.appendChild(info);


                var text = document.createElement('div');
                text.classList.add('product-text');
                text.innerText = item["Text"];
                info.appendChild(text);

                var amount = document.createElement('div');
                amount.classList.add('product-amount');
                amount.innerText = item["Count"];
                info.appendChild(amount);

                var amountHelpText = document.createElement('span');
                amountHelpText.classList.add('product-amount-help-text');
                amountHelpText.innerText = " på lager";
                amount.appendChild(amountHelpText);

                var price = document.createElement('div');
                price.classList.add('product-price');
                // Remove last two characters
                price.innerText = parseFloat(item["PriceBottle"].toString().slice(0, -2)).toFixed(2).replace('.', ',');
                productContainer.appendChild(price);

                var priceCurrency = document.createElement('span');
                priceCurrency.classList.add('product-price-currency');
                priceCurrency.innerText = " DKR.";
                price.appendChild(priceCurrency);

                var priceExchange = document.createElement('div');
                priceExchange.classList.add('product-price-exchange');
                // Remove last two characters
                priceExchange.innerText = parseFloat(item["PriceLPG"].toString().slice(0, -2)).toFixed(2).replace('.', ',');
                productContainer.appendChild(priceExchange);

                var priceExchangeCurrency = document.createElement('span');
                priceExchangeCurrency.classList.add('product-price-currency');
                priceExchangeCurrency.innerText = " DKR.";
                priceExchange.appendChild(priceExchangeCurrency);

                productList.appendChild(productContainer);
            }
            productTemplate.insertBefore(productList, productTemplate.querySelector('.modal__footer-text'));

            $('#js-modal__content-inner').html(productTemplate.cloneNode(true));
            $('.modal__title').text(product.Location);
        }

        //for (var x = 0; x < markers.length; x++) {
        //    if (markers[x].typeGasCenter === "True") {
        //        markers[x].setVisible(true);
        //    } else {
        //        markers[x].setVisible(false);
        //    }
        //}

        if(this.props.model.UseClustering) {
            var clusterStyleOptions = JSON.parse(this.props.model.ClusterStyle);

            var clusterOptions = {
                styles: [
                    {
                        anchor: [parseInt(clusterStyleOptions[0].anchor[0]), parseInt(clusterStyleOptions[0].anchor[1])],
                        textColor: clusterStyleOptions[0].textColor,
                        url: clusterStyleOptions[0].url,
                        width: parseInt(clusterStyleOptions[0].width),
                        height: parseInt(clusterStyleOptions[0].height)
                    },
                    {
                        anchor: [parseInt(clusterStyleOptions[1].anchor[0]), parseInt(clusterStyleOptions[1].anchor[1])],
                        textColor: clusterStyleOptions[1].textColor,
                        url: clusterStyleOptions[1].url,
                        width: parseInt(clusterStyleOptions[1].width),
                        height: parseInt(clusterStyleOptions[1].height)
                    },
                    {
                        anchor: [parseInt(clusterStyleOptions[2].anchor[0]), parseInt(clusterStyleOptions[2].anchor[1])],
                        textColor: clusterStyleOptions[2].textColor,
                        url: clusterStyleOptions[2].url,
                        width: parseInt(clusterStyleOptions[2].width),
                        height: parseInt(clusterStyleOptions[2].height)
                    },
                    {
                        anchor: [parseInt(clusterStyleOptions[3].anchor[0]), parseInt(clusterStyleOptions[3].anchor[1])],
                        textColor: clusterStyleOptions[3].textColor,
                        url: clusterStyleOptions[3].url,
                        width: parseInt(clusterStyleOptions[3].width),
                        height: parseInt(clusterStyleOptions[3].height)
                    },
                    {
                        anchor: [parseInt(clusterStyleOptions[4].anchor[0]), parseInt(clusterStyleOptions[4].anchor[1])],
                        textColor: clusterStyleOptions[4].textColor,
                        url: clusterStyleOptions[4].url,
                        width: parseInt(clusterStyleOptions[4].width),
                        height: parseInt(clusterStyleOptions[4].height)
                    }
                ]
            };

            markerCluster = new MarkerClusterer(map, markers, clusterOptions);//.filter(function (x) { return x.typeGasCenter === "True"; })
        }

        $('#type-normal').click();//for starting at the right place for the map

        if(this.props.model.UseGeoLocation) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    map.setZoom(8);
                    map.setCenter(pos);
                });
            }
        }

        var minZoom = this.props.model.MinZoom;
        var maxZoom = this.props.model.MaxZoom;

        google.maps.event.addListener(map, "zoom_changed", function () {
            if (map.getZoom() < parseInt(minZoom)) map.setZoom(parseInt(minZoom));
            if (map.getZoom() > parseInt(maxZoom)) map.setZoom(parseInt(maxZoom));
        });

        google.maps.event.addDomListener(window, "resize", function() {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });

        this.setState({map: map});
    },

    mapCenterLatLng: function () {

        var Lat, Lng; 
        if ($(".map-container").data("centermap").length > 0)
        {
          //Check if data attribute exsists
          var  centerMap = $(".map-container").data("centermap");
          Lat = centerMap.split(",")[0];
          Lng = centerMap.split(",")[1];
        }
        else
        {
            Lat = this.props.model.Center.split(",")[0];
            Lng = this.props.model.Center.split(",")[1];
        }

        return new google.maps.LatLng(Lat, Lng);
    },

    componentDidUpdate: function () {
        var map = this.state.map;
        map.panTo(this.mapCenterLatLng());
    },

    render: function () {
        var style = {
            width: "100%",
            height: "100%"
        };

        return (
            React.createElement("div", {className: "map", style: style})
        );
    }
});
